export const CLINIC_LOGO_MAX_HEIGHT = "168px";
export const CLINIC_LOGO_MAX_WIDTH = "346px";
